import { observer } from 'mobx-react';
import { FC } from 'react';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { Card } from '@monorepo/base/src/components/card/card';
import { IAdminxStore } from '../../../../stores';
import { DataAttribute } from '@monorepo/tools/src/lib/models/data-attr.model';
import { Toggle } from '@monorepo/base/src/components/form/toggle/toggle';
import { Decisions } from '../../../../enums/decisions';
import { Flex } from '@monorepo/base/src/components/flex/flex';
import { Spacer } from '@monorepo/base/src/components/spacer/spacer';

export const CampaignRules: FC = observer(() => {
	const { campaignStore } = useStores<IAdminxStore>();

	const campaign = campaignStore.getCrud().getData();

	return (
		<Card
			id="campaignRules"
			title="Campaign Rules"
			icon="contrast-01"
			debugProps={{ dataAttrs: [new DataAttribute('id', 'campaign_rules')] }}>
			<Spacer />
			<Flex alignItems="start" flexDirection="column" gap="16px">
				<Toggle
					title={'Allow Multiple Sales?'}
					label={campaign?.getAllowMultipleSales() ? Decisions.Yes : Decisions.No}
					onChange={status => campaign?.setAllowMultipleSales(status)}
					defaultValue={campaign?.getAllowMultipleSales()}
					debugProps={{ dataAttrs: [new DataAttribute('id', 'allow_multiple_sales')] }}
				/>
			</Flex>
		</Card>
	);
});
